var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZonas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1721_807)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.90511 7.50017L5.01851 5.03539C5.08625 4.88542 5.23734 4.79115 5.40263 4.79792C5.56706 4.80439 5.71118 4.90986 5.767 5.06464L7.54588 9.99728L9.21263 6.38374C9.26931 6.26089 9.38367 6.17451 9.51734 6.1537C9.6509 6.13283 9.78623 6.18022 9.87761 6.28003L10.9951 7.50012H14.4097C15.164 5.82116 15.065 4.49574 14.8253 3.64739C14.3393 1.92685 12.75 0.725098 10.9605 0.725098C10.7098 0.725098 10.4542 0.748284 10.2006 0.794C9.17091 0.979693 8.33316 1.52531 7.7779 2.37184C7.67445 2.52949 7.5815 2.69741 7.50002 2.87264C7.41854 2.69741 7.32559 2.52949 7.22213 2.37184C6.66687 1.52526 5.82913 0.979693 4.79948 0.794C4.54584 0.748284 4.29019 0.725098 4.03953 0.725098C2.25003 0.725098 0.660779 1.9268 0.174773 3.64739C-0.0648708 4.49574 -0.163931 5.8211 0.590411 7.50012H3.90511V7.50017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.817 8.30839C10.7037 8.30839 10.5956 8.2608 10.519 8.1772L9.69185 7.27404L7.86684 11.2307C7.80062 11.3743 7.65705 11.4655 7.49995 11.4655C7.49414 11.4655 7.48833 11.4654 7.48247 11.4651C7.31865 11.4581 7.17529 11.3527 7.11967 11.1985L5.34458 6.27637L4.53411 8.07061C4.4687 8.21534 4.32463 8.30839 4.16581 8.30839H1.00635C2.15819 10.2911 4.26775 12.2758 7.28152 14.2111C7.348 14.2539 7.42393 14.2752 7.49985 14.2752C7.57577 14.2752 7.6517 14.2539 7.71818 14.2111C10.732 12.2758 12.8415 10.2911 13.9934 8.30839H10.817Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1721_807"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZonas);
export default __webpack_public_path__ + "static/media/zonas.2e8f276caa7b670bb6510ee906e41313.svg";
export { ForwardRef as ReactComponent };